(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/components/result-sportkryss.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/components/result-sportkryss.js');
"use strict";

const {
  WinDiv
} = svs.components.tipsen.winDiv;
const {
  format
} = svs.utils;
const {
  SportkryssNumbers
} = svs.components.tipsen.SportkryssMybetsResult;
const {
  useSelectedSportkryss,
  ResultSportkryssFallback
} = svs.components.tipsen.routeResult;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  TableHolder
} = svs.components.tipsen.routeResult;
const {
  ReactPaper: Paper
} = svs.ui;
const ResultSportkryss = _ref => {
  var _sportkryssetData$dat, _sportkryssetData$dat2;
  let {
    currentDateDraw,
    month,
    year,
    sportkryssFactors
  } = _ref;
  const className = 'pg_windiv--result pg_windiv--result-sportkryss';
  const [sportkryssetData, loadingSportkrysset] = useSelectedSportkryss(year, month, currentDateDraw, sportkryssFactors);
  const [productBranding] = useBranding();
  if (loadingSportkrysset) {
    return React.createElement(ResultSportkryssFallback, null);
  }
  if (!sportkryssetData || Object.keys(sportkryssetData) === 0) {
    return null;
  }
  return React.createElement(TableHolder, {
    label: "Sportkryss"
  }, React.createElement(Paper, {
    branding: "sport"
  }, React.createElement("div", {
    className: "sportkryss-lg-cicle-container pg_sportkryss__result_page"
  }, React.createElement(SportkryssNumbers, {
    branding: productBranding,
    sportkryssetResultData: sportkryssetData === null || sportkryssetData === void 0 || (_sportkryssetData$dat = sportkryssetData.data) === null || _sportkryssetData$dat === void 0 || (_sportkryssetData$dat = _sportkryssetData$dat.result) === null || _sportkryssetData$dat === void 0 || (_sportkryssetData$dat = _sportkryssetData$dat.drawResult) === null || _sportkryssetData$dat === void 0 ? void 0 : _sportkryssetData$dat.numbers
  })), React.createElement(WinDiv, {
    className: className,
    drawWinDivs: sportkryssetData === null || sportkryssetData === void 0 ? void 0 : sportkryssetData.winDivArray,
    isSportkryss: true
  }), React.createElement("p", {
    className: "sportkryss-turnover"
  }, React.createElement("span", null, "Oms\xE4ttning:"), React.createElement("span", {
    className: "turnover-value"
  }, "".concat(format.Currency(parseInt((_sportkryssetData$dat2 = sportkryssetData.data) === null || _sportkryssetData$dat2 === void 0 || (_sportkryssetData$dat2 = _sportkryssetData$dat2.result) === null || _sportkryssetData$dat2 === void 0 ? void 0 : _sportkryssetData$dat2.currentNetSale, 10)), " kr")))));
};
setGlobal('svs.components.tipsen.routeResult.ResultSportkryss', ResultSportkryss);

 })(window);